import { slugify, slugifyCollection } from "./slugify"

export const linksBuilder = {
  artworks: (id, str) => `/artworks/${id}-${slugify(str)}`,
  galleries: (str) => `/galleries/${str}`,
  collections: (id, collection) =>
    `/galleries/${id}/collections/${slugifyCollection(collection)}`,
}
